import {Text, View} from "react-native";
import React from 'react';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

const ACCENT = '#3C8248';

const FilterModalRangeFilter = ({fieldName, fieldValue, fieldValueSetter, min, max, step = 1, unitName = ""}) => {
    const [containerWidth, setContainerWidth] = React.useState(0);

    const clamp = (n: number, lo: number, hi: number) => Math.max(lo, Math.min(hi, n));

    const [minValue, maxValue] = fieldValue || [min, max];
    const ratio = (v: number) => (v - min) / (max - min);
    const leftPx = clamp(Math.round(ratio(minValue) * containerWidth), 0, containerWidth);
    const rightPx = clamp(Math.round(ratio(maxValue) * containerWidth), 0, containerWidth);

    const bars = React.useMemo(() => {
        const count = 28; // number of bars
        const arr: number[] = [];
        for (let i = 0; i < count; i++) {
            // Create a pleasant hill shape
            const t = (i / (count - 1)) * Math.PI;
            const h = Math.sin(t) ** 1.6; // tweak for shape
            arr.push(h);
        }
        return arr;
    }, []);

    return (
        <View style={{
            marginBottom: 24,
            backgroundColor: '#FFFFFF',
            borderRadius: 16,
            padding: 16,
            borderWidth: 1,
            borderColor: '#E5E7EB',
            shadowColor: '#000',
            shadowOpacity: 0.06,
            shadowRadius: 8,
            shadowOffset: { width: 0, height: 3 },
        }}>
            <View style={{flexDirection: 'row', alignItems: 'center', marginBottom: 16}}>
                <Text style={{
                    fontSize: 16,
                    fontWeight: '700',
                    color: '#111827',
                }}>
                    {fieldName}
                </Text>
                <View style={{flex: 1}} />
            </View>

            <View
                onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}
                style={{ position: 'relative' }}
            >
                {/* Decorative histogram */}
                <View style={{
                    height: 48,
                    flexDirection: 'row',
                    alignItems: 'flex-end',
                    marginBottom: 8,
                    gap: 3,
                    paddingHorizontal: 2,
                }}>
                    {bars.map((h, i) => (
                        <View
                            key={i}
                            style={{
                                flex: 1,
                                height: Math.max(6, Math.round(h * 44)),
                                borderTopLeftRadius: 2,
                                borderTopRightRadius: 2,
                                backgroundColor: `rgba(60,130,72,${0.25 + h * 0.55})`,
                            }}
                        />
                    ))}
                </View>

                {/* Glow indicators under thumbs */}
                <View style={{ position: 'absolute', top: 16, left: Math.max(0, leftPx - 10), width: 20, height: 20, borderRadius: 10, backgroundColor: ACCENT, opacity: 0.15 }} />
                <View style={{ position: 'absolute', top: 16, left: Math.max(0, rightPx - 10), width: 20, height: 20, borderRadius: 10, backgroundColor: ACCENT, opacity: 0.15 }} />

                <RangeSlider
                    min={min}
                    max={max}
                    step={step}
                    color={ACCENT}
                    onInput={(value) => {
                        fieldValueSetter(value);
                    }}
                    value={fieldValue}
                />

                {/* Floating value bubbles */}
                <View style={{
                    position: 'absolute',
                    top: -6,
                    left: Math.max(0, leftPx - 22),
                    backgroundColor: ACCENT,
                    paddingHorizontal: 8,
                    paddingVertical: 4,
                    borderRadius: 6,
                }}>
                    <Text style={{ fontSize: 11, color: 'white', fontWeight: '700' }}>{minValue}{unitName}</Text>
                </View>
                <View style={{
                    position: 'absolute',
                    top: -6,
                    left: Math.max(0, rightPx - 22),
                    backgroundColor: ACCENT,
                    paddingHorizontal: 8,
                    paddingVertical: 4,
                    borderRadius: 6,
                }}>
                    <Text style={{ fontSize: 11, color: 'white', fontWeight: '700' }}>{maxValue}{unitName}</Text>
                </View>
            </View>
        </View>
    );
};

export default FilterModalRangeFilter; 